import React from 'react';
import { Hero } from '../components/Hero';
import { ProblemNarrative } from '../components/ProblemNarrative';
import { SolutionMechanism } from '../components/SolutionMechanism';
import { DeepDive } from '../components/DeepDive';
import { ProgramBreakdown } from '../components/ProgramBreakdown';
import { FinalPromise } from '../components/FinalPromise';
export function LandingPage() {
  return <main className="min-h-screen bg-[#fcfbf7] overflow-x-hidden" data-id="element-239">
      <Hero data-id="element-240" />
      <ProblemNarrative data-id="element-241" />
      <SolutionMechanism data-id="element-242" />
      <DeepDive data-id="element-243" />
      <ProgramBreakdown data-id="element-244" />
      <FinalPromise data-id="element-245" />
    </main>;
}